module.exports = __webpack_public_path__ + "img/house-ge8e9e5e2d_1920.21d2cde3.jpg";